import React from 'react'
import '../css/notfound.scss'
export default function NotFound() {
    return (
        <div className="notFound">
             <h1>4<span className='zero'>0</span>4</h1>
             <h5>
                 <span className="a1">Something </span>
                 <span className="a3">went </span>
                 <span className="a4">wrong </span>
                 <span className="a5">I </span>
                 <span className="a6">can </span>
                 <span className="a7">feel </span>
                 <span className="a8">it </span>
                       
                 
                 
                 </h5>
        </div>
    )
}
